module.exports = __webpack_public_path__ + "static/media/4.be7eac93.webp";